module.exports = __webpack_public_path__ + "static/img/2A.140fa3d8.svg";